module.exports = __webpack_public_path__ + "img/menu-off_03.00242a71.png";